import React from "react";
import PostPreview from "./PostListItem";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";

function PostList() {
    const blogsRef = db.collection("blogs");
    const query = blogsRef.orderBy('createdAt', 'desc').limit(25);
    const [posts, loading, error] = useCollectionData(query, {idField: "id"}); 
    return (
        <section className="col-md-8" id="PostListContainer">
            <h2>Latest Posts</h2>
            <div className="container-fluid ps-0 p-0">
            {loading && <h1>Loading...</h1>}
            {error && <h1>{error}</h1>}
            {posts && posts.map(post => (
                <PostPreview 
                    key={post.id}
                    title={post.title}
                    featuredImg={post.featuredImg}
                    description={post.description}
                    author={post.author}
                    time={post.createdAt}
                />
            ))
            }
            </div>
        </section>
    );
}

export default PostList;